import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import './Home.css';
import { FaUser, FaCog, FaCalendarAlt, FaGlobe, FaFileAlt, FaHome, FaSignOutAlt } from 'react-icons/fa';
import { HiDocumentReport } from "react-icons/hi";

import { Outlet } from 'react-router-dom';
import fgIdentitySolutions from '../../../assets/Images/fgIdentitySolutions.jpg'
import { getServicesByRoleId, logoutService } from "../../../services/loginService";
import { capitalizeFirstLetter } from '../../../utils/validations';
const Home = ({ logout }) => {
  const [assignedServices, setAssignedServices] = useState([]);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [error, setError] = useState(null); // For error feedback
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const employeeUniqueId = searchParams.get('employeeUniqueId');
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const username = localStorage.getItem('username');
  const full_name = localStorage.getItem('full_name');
  const roleId = localStorage.getItem("roleId");
  const token = localStorage.getItem("token");
  const closeTimer = React.useRef(null);
  const [activePath, setActivePath] = useState([]);
  // Fetch services based on roleId
  useEffect(() => {
    if (!roleId) {
      console.log("No roleId found, skipping API call");
      setError("No role ID available. Please log in again.");
      return;
    }

    const fetchServices = async () => {
      try {
        console.log("Fetching services for roleId:", roleId);
        const data = await getServicesByRoleId(roleId);
        console.log("API Response:", data);

        // filter assigned services
        const filterServices = (services) => {
          return services
            .map((s) => {
              const children = filterServices(s.childServices || []);

              // ✅ keep if:
              // - self assigned
              // - OR any child exists (even deep child)
              if (s.assigned || children.length > 0) {
                return {
                  ...s,
                  childServices: children,
                };
              }

              return null;
            })
            .filter(Boolean);
        };

        const filteredServices = filterServices(data);
        console.log("Filtered Services:", filteredServices);

        setAssignedServices(filteredServices);
        setError(null);
      } catch (err) {
        console.error("Error fetching services:", err);
        setAssignedServices([]);
        setError("Failed to load services. Please try again.");
      }
    };

    fetchServices();
  }, [roleId]);
  // ✅ RECURSIVE CHECK (FIXED)
  const hasAssignedDeepChild = (services) => {
    return services.some((s) => {
      if (s.assigned) return true;
      if (s.childServices?.length) {
        return hasAssignedDeepChild(s.childServices);
      }
      return false;
    });
  };
  const getIcon = (serviceName) => {
    if (!serviceName) return FaFileAlt;

    const normalized = serviceName.replace(/\s+/g, '').toLowerCase();

    const icons = {
      usermanagement: FaUser,
      admin: FaUser,
      leavemanagement: FaCalendarAlt,
      attendance: FaCalendarAlt,
      employee: FaGlobe,
      monthlyactivities: FaCalendarAlt,
      reports: HiDocumentReport,
    };

    return icons[normalized] || FaFileAlt;
  };
  // // Close sidebar automatically whenever the route changes
  // useEffect(() => {
  //   setIsSidebarOpen(false);
  //   setActiveDropdown(null);
  // }, [location.pathname]);
  useEffect(() => {
    console.log("🔁 Route changed:", location.pathname, location.key);
    setIsSidebarOpen(false);
    setActiveDropdown(null);
  }, [location.pathname, location.key]);


  const renderServiceLinks = useCallback(
    (services, level = 0, parentPath = []) => {
      return services.map((service) => {
        const hasChildren = service.childServices?.length > 0;

        const currentPath = [...parentPath, service.serviceId];

        const isActive =
          activePath.length >= currentPath.length &&
          currentPath.every((id, i) => activePath[i] === id);

        const hasAssignedChildren =
          hasChildren && hasAssignedDeepChild(service.childServices);

        if (!service.assigned && !hasAssignedChildren) return null;

        const formatServiceName = (name) =>
          name.replace(/([a-z])([A-Z])/g, "$1 $2");

        const Icon = level === 0 ? getIcon(service.serviceName) : null;

        // if (hasChildren) {
        //   return (
        //     // <div
        //     //   key={service.serviceId}
        //     //   className="sidebar-link"
        //     //   style={{ paddingLeft: `${level * 15}px` }}
        //     //   onMouseEnter={() => {
        //     //     setActivePath(currentPath); // ✅ track full path
        //     //   }}
        //     //   onMouseLeave={() => {
        //     //     setActivePath((prev) =>
        //     //       prev.slice(0, level) // ✅ only close current level
        //     //     );
        //     //   }}
        //     // >
        //     <div
        //       key={service.serviceId}
        //       className="sidebar-link"
        //       style={{ paddingLeft: `${level * 15}px` }}
        //       onClick={() => {
        //         setActivePath((prev) => {
        //           const isCurrentlyActive =
        //             prev.length >= currentPath.length &&
        //             currentPath.every((id, i) => prev[i] === id);

        //           if (isCurrentlyActive) {
        //             // Close this dropdown
        //             return prev.slice(0, level);
        //           }

        //           // Open this dropdown
        //           return currentPath;
        //         });
        //       }}
        //     >

        //       <div className="dropdown-header">
        //         {Icon && <Icon className="icon" />}
        //         {formatServiceName(service.serviceName)}
        //         <span className="arrow">{isActive ? " ▲" : " ▼"}</span>
        //       </div>

        //       {isActive && (
        //         <div className="dropdown-items">
        //           {renderServiceLinks(
        //             service.childServices,
        //             level + 1,
        //             currentPath
        //           )}
        //         </div>
        //       )}
        //     </div>
        //   );
        // }
        if (hasChildren) {
          return (
            <div
              key={service.serviceId}
              className="sidebar-link"
              style={{ paddingLeft: `${level * 15}px` }}
            >
              <div
                className="dropdown-header"
                onClick={(e) => {
                  e.stopPropagation();

                  setActivePath((prev) => {
                    const isCurrentlyActive =
                      prev.length >= currentPath.length &&
                      currentPath.every((id, i) => prev[i] === id);

                    if (isCurrentlyActive) {
                      // Close this level and everything below it
                      return prev.slice(0, level);
                    }

                    // Open this level and keep its parent levels open
                    return currentPath;
                  });
                }}
              >
                {Icon && <Icon className="icon" />}

                {formatServiceName(service.serviceName)}

                <span className="arrow">
                  {isActive ? " ▲" : " ▼"}
                </span>
              </div>

              {isActive && (
                <div className="dropdown-items">
                  {renderServiceLinks(
                    service.childServices,
                    level + 1,
                    currentPath
                  )}
                </div>
              )}
            </div>
          );
        }
        // return (
        //   <div
        //     key={service.serviceId}
        //     className="sidebar-link"
        //     style={{ paddingLeft: `${level * 15}px` }}
        //   >
        //     <Link to={service.serviceLink}>
        //       - {formatServiceName(service.serviceName)}
        //     </Link>

        //   </div>
        // );

        return (
          <div
            key={service.serviceId}
            className="sidebar-link"
            style={{ paddingLeft: `${level * 15}px` }}
          >
            <Link
              to={service.serviceLink}
              onClick={(e) => {
                e.stopPropagation();
                // Close Parent Menu + Sub Menu
                setActivePath([]);
              }}
            >
              - {formatServiceName(service.serviceName)}
            </Link>
          </div>
        );
      });
    },
    [activePath]
  );

  const handleLogin = () => navigate('/login');

  const handleLogout = async () => {
    try {
      const employeeId = localStorage.getItem('employeeId');
      if (!employeeId) {
        console.error("No employeeId found in localStorage");
        setError("No employee ID found. Please log in again.");
        return;
      }

      const result = await logoutService(employeeId);

      if (result.success) {

        window.location.href = '/login';
      }



      // Clear localStorage
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('username');
      localStorage.removeItem('employeeId');
      localStorage.removeItem('role');
      localStorage.removeItem('email');
      localStorage.removeItem('full_name');
      localStorage.removeItem('user');
      localStorage.removeItem('roleId');
      localStorage.removeItem('token');

      // Call logout prop and navigate to login
      logout();
      navigate("/login", { replace: true });
    } catch (err) {
      console.error("Logout API error:", err);
      setError("Failed to logout. Please try again.");
    }
  };

  const handleChildClick = () => {
    if (window.innerWidth <= 768) {
      setIsSidebarOpen(false);     // close sidebar
      setActiveDropdown([]);     // collapse parent
    }
  };


  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="home-container">
      <div className={`part-1 ${isSidebarOpen ? "sidebar-open" : ""}`}>
        {isLoggedIn && (
          <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
            <div className="sidebar-top">
              <div className="sidebar-link">
                <Link to="/home" onClick={handleChildClick}>
                  <FaHome className="icon" /> Home
                </Link>
              </div>
              {error && <div className="error-message">{error}</div>}
              {renderServiceLinks(assignedServices)}
              <div className="sidebar-link">
                <Link to="/login" onClick={handleLogout}>
                  <FaSignOutAlt className="icon" /> Logout
                </Link>
              </div>
            </div>
          </div>
        )}

        <nav className="navbar">
          <div className="navbar-items-style">
            {isLoggedIn && (
              <div className="hamburger-menu" onClick={toggleSidebar}>
                &#9776;
              </div>
            )}
            <img
              src={fgIdentitySolutions}
              style={{ width: '50px', height: '30px', marginLeft: '10px', borderRadius: '15px' }}
              alt="Logo"
            />
            <h4 style={{ fontFamily: 'sans-serif', marginLeft: '10px' }}>HRMS</h4>
          </div>
          <div className="auth-container">
            {isLoggedIn ? (
              <>
                <span className="username">{capitalizeFirstLetter(full_name)}</span>
                <button className="login-button" onClick={handleLogout}>
                  LOGOUT
                </button>
              </>
            ) : employeeUniqueId ? null : (
              <button className="login-button" onClick={handleLogin}>
                LOGIN
              </button>
            )}
          </div>
        </nav>
      </div>

      <div className={`part-2 ${isSidebarOpen ? "sidebar-open" : ""}`}>
        <div className="main-content">
          <Outlet />
        </div>
      </div>

      <footer className="footer">
        <div className="footer-content">
          <div className="fixed-1">Copyright&copy; 2025 | All Rights Reserved.</div>
          <div className="fixed-2">
            Designed and Developed by{" "}
            <a className="text-a" href="https://www.4gid.com/" target="_blank" rel="noopener noreferrer">
              4G Identity Solutions Pvt. Ltd.
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
